var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import List from "../search/list";
export default function HistoryList(_a) {
    var _b;
    var widget = _a.widget, onChange = _a.onChange;
    var dataRecord = Object.values((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.records).map(function (item) { return (__assign({}, item)); }) || [];
    var columns = [
        {
            header: "Module",
            name: "module_name",
        },
        {
            header: "Summary",
            name: "item_summary",
        },
        {
            header: "Actions",
            name: "item_actions",
        },
        { header: "Date Modified", name: "date_modified" },
    ];
    return (_jsxs("div", { children: [_jsx("h1", __assign({ className: "uppercase m-2 font-bold" }, { children: "Historique" })), _jsx("div", __assign({ className: "relative mr-2" }, { children: _jsx(List, { record: dataRecord, perPage: 10, isSearch: false, columns: columns }) }))] }));
}
widgetsDictionary.register("widget/home/historyList", {
    name: "Tous les historiques",
    validation: true,
    display: HistoryList,
    selectable: false,
});
